/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AccessDeniedRouteImport } from './routes/access-denied'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UsersIndexRouteImport } from './routes/users/index'
import { Route as SupportIndexRouteImport } from './routes/support/index'
import { Route as SubscriptionsIndexRouteImport } from './routes/subscriptions/index'
import { Route as QuotaReportIndexRouteImport } from './routes/quota-report/index'
import { Route as PlansIndexRouteImport } from './routes/plans/index'
import { Route as InvoicesIndexRouteImport } from './routes/invoices/index'
import { Route as CourseLibraryIndexRouteImport } from './routes/course-library/index'
import { Route as ClientsIndexRouteImport } from './routes/clients/index'
import { Route as ClientHealthIndexRouteImport } from './routes/client-health/index'
import { Route as ChecklistLibraryIndexRouteImport } from './routes/checklist-library/index'
import { Route as AssociationsIndexRouteImport } from './routes/associations/index'
import { Route as AgenciesIndexRouteImport } from './routes/agencies/index'
import { Route as AdminRolesIndexRouteImport } from './routes/admin-roles/index'
import { Route as UsersUserIdRouteImport } from './routes/users/$userId'
import { Route as SupportSettingsRouteImport } from './routes/support/settings'
import { Route as SubscriptionsSubscriptionIdRouteImport } from './routes/subscriptions/$subscriptionId'
import { Route as PlansPlanIdRouteImport } from './routes/plans/$planId'
import { Route as InvoicesInvoiceIdRouteImport } from './routes/invoices/$invoiceId'
import { Route as ClientsCreateRouteImport } from './routes/clients/create'
import { Route as ClientOnboardingRouteImport } from './routes/client/onboarding'
import { Route as ClientLocationsRouteImport } from './routes/client/locations'
import { Route as ClientLayoutModesRouteImport } from './routes/client/layout-modes'
import { Route as ClientDetailsRouteImport } from './routes/client/details'
import { Route as ClientDashboardRouteImport } from './routes/client/dashboard'
import { Route as ClientChecklistsRouteImport } from './routes/client/checklists'
import { Route as ClientChecklistLibraryRouteImport } from './routes/client/checklist-library'
import { Route as ClientAssetsRouteImport } from './routes/client/assets'
import { Route as ClientAssetGroupsRouteImport } from './routes/client/asset-groups'
import { Route as ClientHealthClientIdRouteImport } from './routes/client-health/$clientId'
import { Route as ChecklistLibrarySystemChecklistIdRouteImport } from './routes/checklist-library/$systemChecklistId'
import { Route as AssociationsAssociationIdRouteImport } from './routes/associations/$associationId'
import { Route as AgenciesAgencyIdRouteImport } from './routes/agencies/$agencyId'
import { Route as AdminRolesRoleIdRouteImport } from './routes/admin-roles/$roleId'
import { Route as CourseLibraryTermsIndexRouteImport } from './routes/course-library/terms/index'
import { Route as ClientUsersIndexRouteImport } from './routes/client/users/index'
import { Route as ClientRolesIndexRouteImport } from './routes/client/roles/index'
import { Route as ClientLocationsIndexRouteImport } from './routes/client/locations/index'
import { Route as ClientGroupsIndexRouteImport } from './routes/client/groups/index'
import { Route as ClientAssetsIndexRouteImport } from './routes/client/assets/index'
import { Route as ClientAssetGroupsIndexRouteImport } from './routes/client/asset-groups/index'
import { Route as SupportTicketsTicketIdRouteImport } from './routes/support/tickets/$ticketId'
import { Route as CourseLibraryCoursesCourseIdRouteImport } from './routes/course-library/courses/$courseId'
import { Route as ClientUsersCreateRouteImport } from './routes/client/users/create'
import { Route as ClientUsersUserIdRouteImport } from './routes/client/users/$userId'
import { Route as ClientRolesCreateRouteImport } from './routes/client/roles/create'
import { Route as ClientRolesRoleIdRouteImport } from './routes/client/roles/$roleId'
import { Route as ClientLocationsCreateRouteImport } from './routes/client/locations/create'
import { Route as ClientLocationsLocationIdRouteImport } from './routes/client/locations/$locationId'
import { Route as ClientGroupsCreateRouteImport } from './routes/client/groups/create'
import { Route as ClientGroupsGroupIdRouteImport } from './routes/client/groups/$groupId'
import { Route as ClientAssetsCreateRouteImport } from './routes/client/assets/create'
import { Route as ClientAssetsAssetIdRouteImport } from './routes/client/assets/$assetId'
import { Route as ClientAssetGroupsGroupIdRouteImport } from './routes/client/asset-groups/$groupId'

const AccessDeniedRoute = AccessDeniedRouteImport.update({
  id: '/access-denied',
  path: '/access-denied',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersIndexRoute = UsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => rootRouteImport,
} as any)
const SupportIndexRoute = SupportIndexRouteImport.update({
  id: '/support/',
  path: '/support/',
  getParentRoute: () => rootRouteImport,
} as any)
const SubscriptionsIndexRoute = SubscriptionsIndexRouteImport.update({
  id: '/subscriptions/',
  path: '/subscriptions/',
  getParentRoute: () => rootRouteImport,
} as any)
const QuotaReportIndexRoute = QuotaReportIndexRouteImport.update({
  id: '/quota-report/',
  path: '/quota-report/',
  getParentRoute: () => rootRouteImport,
} as any)
const PlansIndexRoute = PlansIndexRouteImport.update({
  id: '/plans/',
  path: '/plans/',
  getParentRoute: () => rootRouteImport,
} as any)
const InvoicesIndexRoute = InvoicesIndexRouteImport.update({
  id: '/invoices/',
  path: '/invoices/',
  getParentRoute: () => rootRouteImport,
} as any)
const CourseLibraryIndexRoute = CourseLibraryIndexRouteImport.update({
  id: '/course-library/',
  path: '/course-library/',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientsIndexRoute = ClientsIndexRouteImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientHealthIndexRoute = ClientHealthIndexRouteImport.update({
  id: '/client-health/',
  path: '/client-health/',
  getParentRoute: () => rootRouteImport,
} as any)
const ChecklistLibraryIndexRoute = ChecklistLibraryIndexRouteImport.update({
  id: '/checklist-library/',
  path: '/checklist-library/',
  getParentRoute: () => rootRouteImport,
} as any)
const AssociationsIndexRoute = AssociationsIndexRouteImport.update({
  id: '/associations/',
  path: '/associations/',
  getParentRoute: () => rootRouteImport,
} as any)
const AgenciesIndexRoute = AgenciesIndexRouteImport.update({
  id: '/agencies/',
  path: '/agencies/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRolesIndexRoute = AdminRolesIndexRouteImport.update({
  id: '/admin-roles/',
  path: '/admin-roles/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersUserIdRoute = UsersUserIdRouteImport.update({
  id: '/users/$userId',
  path: '/users/$userId',
  getParentRoute: () => rootRouteImport,
} as any)
const SupportSettingsRoute = SupportSettingsRouteImport.update({
  id: '/support/settings',
  path: '/support/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SubscriptionsSubscriptionIdRoute =
  SubscriptionsSubscriptionIdRouteImport.update({
    id: '/subscriptions/$subscriptionId',
    path: '/subscriptions/$subscriptionId',
    getParentRoute: () => rootRouteImport,
  } as any)
const PlansPlanIdRoute = PlansPlanIdRouteImport.update({
  id: '/plans/$planId',
  path: '/plans/$planId',
  getParentRoute: () => rootRouteImport,
} as any)
const InvoicesInvoiceIdRoute = InvoicesInvoiceIdRouteImport.update({
  id: '/invoices/$invoiceId',
  path: '/invoices/$invoiceId',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientsCreateRoute = ClientsCreateRouteImport.update({
  id: '/clients/create',
  path: '/clients/create',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientOnboardingRoute = ClientOnboardingRouteImport.update({
  id: '/client/onboarding',
  path: '/client/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientLocationsRoute = ClientLocationsRouteImport.update({
  id: '/client/locations',
  path: '/client/locations',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientLayoutModesRoute = ClientLayoutModesRouteImport.update({
  id: '/client/layout-modes',
  path: '/client/layout-modes',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientDetailsRoute = ClientDetailsRouteImport.update({
  id: '/client/details',
  path: '/client/details',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientDashboardRoute = ClientDashboardRouteImport.update({
  id: '/client/dashboard',
  path: '/client/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientChecklistsRoute = ClientChecklistsRouteImport.update({
  id: '/client/checklists',
  path: '/client/checklists',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientChecklistLibraryRoute = ClientChecklistLibraryRouteImport.update({
  id: '/client/checklist-library',
  path: '/client/checklist-library',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientAssetsRoute = ClientAssetsRouteImport.update({
  id: '/client/assets',
  path: '/client/assets',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientAssetGroupsRoute = ClientAssetGroupsRouteImport.update({
  id: '/client/asset-groups',
  path: '/client/asset-groups',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientHealthClientIdRoute = ClientHealthClientIdRouteImport.update({
  id: '/client-health/$clientId',
  path: '/client-health/$clientId',
  getParentRoute: () => rootRouteImport,
} as any)
const ChecklistLibrarySystemChecklistIdRoute =
  ChecklistLibrarySystemChecklistIdRouteImport.update({
    id: '/checklist-library/$systemChecklistId',
    path: '/checklist-library/$systemChecklistId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AssociationsAssociationIdRoute =
  AssociationsAssociationIdRouteImport.update({
    id: '/associations/$associationId',
    path: '/associations/$associationId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AgenciesAgencyIdRoute = AgenciesAgencyIdRouteImport.update({
  id: '/agencies/$agencyId',
  path: '/agencies/$agencyId',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRolesRoleIdRoute = AdminRolesRoleIdRouteImport.update({
  id: '/admin-roles/$roleId',
  path: '/admin-roles/$roleId',
  getParentRoute: () => rootRouteImport,
} as any)
const CourseLibraryTermsIndexRoute = CourseLibraryTermsIndexRouteImport.update({
  id: '/course-library/terms/',
  path: '/course-library/terms/',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientUsersIndexRoute = ClientUsersIndexRouteImport.update({
  id: '/client/users/',
  path: '/client/users/',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientRolesIndexRoute = ClientRolesIndexRouteImport.update({
  id: '/client/roles/',
  path: '/client/roles/',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientLocationsIndexRoute = ClientLocationsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ClientLocationsRoute,
} as any)
const ClientGroupsIndexRoute = ClientGroupsIndexRouteImport.update({
  id: '/client/groups/',
  path: '/client/groups/',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientAssetsIndexRoute = ClientAssetsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ClientAssetsRoute,
} as any)
const ClientAssetGroupsIndexRoute = ClientAssetGroupsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ClientAssetGroupsRoute,
} as any)
const SupportTicketsTicketIdRoute = SupportTicketsTicketIdRouteImport.update({
  id: '/support/tickets/$ticketId',
  path: '/support/tickets/$ticketId',
  getParentRoute: () => rootRouteImport,
} as any)
const CourseLibraryCoursesCourseIdRoute =
  CourseLibraryCoursesCourseIdRouteImport.update({
    id: '/course-library/courses/$courseId',
    path: '/course-library/courses/$courseId',
    getParentRoute: () => rootRouteImport,
  } as any)
const ClientUsersCreateRoute = ClientUsersCreateRouteImport.update({
  id: '/client/users/create',
  path: '/client/users/create',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientUsersUserIdRoute = ClientUsersUserIdRouteImport.update({
  id: '/client/users/$userId',
  path: '/client/users/$userId',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientRolesCreateRoute = ClientRolesCreateRouteImport.update({
  id: '/client/roles/create',
  path: '/client/roles/create',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientRolesRoleIdRoute = ClientRolesRoleIdRouteImport.update({
  id: '/client/roles/$roleId',
  path: '/client/roles/$roleId',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientLocationsCreateRoute = ClientLocationsCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => ClientLocationsRoute,
} as any)
const ClientLocationsLocationIdRoute =
  ClientLocationsLocationIdRouteImport.update({
    id: '/$locationId',
    path: '/$locationId',
    getParentRoute: () => ClientLocationsRoute,
  } as any)
const ClientGroupsCreateRoute = ClientGroupsCreateRouteImport.update({
  id: '/client/groups/create',
  path: '/client/groups/create',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientGroupsGroupIdRoute = ClientGroupsGroupIdRouteImport.update({
  id: '/client/groups/$groupId',
  path: '/client/groups/$groupId',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientAssetsCreateRoute = ClientAssetsCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => ClientAssetsRoute,
} as any)
const ClientAssetsAssetIdRoute = ClientAssetsAssetIdRouteImport.update({
  id: '/$assetId',
  path: '/$assetId',
  getParentRoute: () => ClientAssetsRoute,
} as any)
const ClientAssetGroupsGroupIdRoute =
  ClientAssetGroupsGroupIdRouteImport.update({
    id: '/$groupId',
    path: '/$groupId',
    getParentRoute: () => ClientAssetGroupsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/access-denied': typeof AccessDeniedRoute
  '/admin-roles/$roleId': typeof AdminRolesRoleIdRoute
  '/agencies/$agencyId': typeof AgenciesAgencyIdRoute
  '/associations/$associationId': typeof AssociationsAssociationIdRoute
  '/checklist-library/$systemChecklistId': typeof ChecklistLibrarySystemChecklistIdRoute
  '/client-health/$clientId': typeof ClientHealthClientIdRoute
  '/client/asset-groups': typeof ClientAssetGroupsRouteWithChildren
  '/client/assets': typeof ClientAssetsRouteWithChildren
  '/client/checklist-library': typeof ClientChecklistLibraryRoute
  '/client/checklists': typeof ClientChecklistsRoute
  '/client/dashboard': typeof ClientDashboardRoute
  '/client/details': typeof ClientDetailsRoute
  '/client/layout-modes': typeof ClientLayoutModesRoute
  '/client/locations': typeof ClientLocationsRouteWithChildren
  '/client/onboarding': typeof ClientOnboardingRoute
  '/clients/create': typeof ClientsCreateRoute
  '/invoices/$invoiceId': typeof InvoicesInvoiceIdRoute
  '/plans/$planId': typeof PlansPlanIdRoute
  '/subscriptions/$subscriptionId': typeof SubscriptionsSubscriptionIdRoute
  '/support/settings': typeof SupportSettingsRoute
  '/users/$userId': typeof UsersUserIdRoute
  '/admin-roles': typeof AdminRolesIndexRoute
  '/agencies': typeof AgenciesIndexRoute
  '/associations': typeof AssociationsIndexRoute
  '/checklist-library': typeof ChecklistLibraryIndexRoute
  '/client-health': typeof ClientHealthIndexRoute
  '/clients': typeof ClientsIndexRoute
  '/course-library': typeof CourseLibraryIndexRoute
  '/invoices': typeof InvoicesIndexRoute
  '/plans': typeof PlansIndexRoute
  '/quota-report': typeof QuotaReportIndexRoute
  '/subscriptions': typeof SubscriptionsIndexRoute
  '/support': typeof SupportIndexRoute
  '/users': typeof UsersIndexRoute
  '/client/asset-groups/$groupId': typeof ClientAssetGroupsGroupIdRoute
  '/client/assets/$assetId': typeof ClientAssetsAssetIdRoute
  '/client/assets/create': typeof ClientAssetsCreateRoute
  '/client/groups/$groupId': typeof ClientGroupsGroupIdRoute
  '/client/groups/create': typeof ClientGroupsCreateRoute
  '/client/locations/$locationId': typeof ClientLocationsLocationIdRoute
  '/client/locations/create': typeof ClientLocationsCreateRoute
  '/client/roles/$roleId': typeof ClientRolesRoleIdRoute
  '/client/roles/create': typeof ClientRolesCreateRoute
  '/client/users/$userId': typeof ClientUsersUserIdRoute
  '/client/users/create': typeof ClientUsersCreateRoute
  '/course-library/courses/$courseId': typeof CourseLibraryCoursesCourseIdRoute
  '/support/tickets/$ticketId': typeof SupportTicketsTicketIdRoute
  '/client/asset-groups/': typeof ClientAssetGroupsIndexRoute
  '/client/assets/': typeof ClientAssetsIndexRoute
  '/client/groups': typeof ClientGroupsIndexRoute
  '/client/locations/': typeof ClientLocationsIndexRoute
  '/client/roles': typeof ClientRolesIndexRoute
  '/client/users': typeof ClientUsersIndexRoute
  '/course-library/terms': typeof CourseLibraryTermsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/access-denied': typeof AccessDeniedRoute
  '/admin-roles/$roleId': typeof AdminRolesRoleIdRoute
  '/agencies/$agencyId': typeof AgenciesAgencyIdRoute
  '/associations/$associationId': typeof AssociationsAssociationIdRoute
  '/checklist-library/$systemChecklistId': typeof ChecklistLibrarySystemChecklistIdRoute
  '/client-health/$clientId': typeof ClientHealthClientIdRoute
  '/client/checklist-library': typeof ClientChecklistLibraryRoute
  '/client/checklists': typeof ClientChecklistsRoute
  '/client/dashboard': typeof ClientDashboardRoute
  '/client/details': typeof ClientDetailsRoute
  '/client/layout-modes': typeof ClientLayoutModesRoute
  '/client/onboarding': typeof ClientOnboardingRoute
  '/clients/create': typeof ClientsCreateRoute
  '/invoices/$invoiceId': typeof InvoicesInvoiceIdRoute
  '/plans/$planId': typeof PlansPlanIdRoute
  '/subscriptions/$subscriptionId': typeof SubscriptionsSubscriptionIdRoute
  '/support/settings': typeof SupportSettingsRoute
  '/users/$userId': typeof UsersUserIdRoute
  '/admin-roles': typeof AdminRolesIndexRoute
  '/agencies': typeof AgenciesIndexRoute
  '/associations': typeof AssociationsIndexRoute
  '/checklist-library': typeof ChecklistLibraryIndexRoute
  '/client-health': typeof ClientHealthIndexRoute
  '/clients': typeof ClientsIndexRoute
  '/course-library': typeof CourseLibraryIndexRoute
  '/invoices': typeof InvoicesIndexRoute
  '/plans': typeof PlansIndexRoute
  '/quota-report': typeof QuotaReportIndexRoute
  '/subscriptions': typeof SubscriptionsIndexRoute
  '/support': typeof SupportIndexRoute
  '/users': typeof UsersIndexRoute
  '/client/asset-groups/$groupId': typeof ClientAssetGroupsGroupIdRoute
  '/client/assets/$assetId': typeof ClientAssetsAssetIdRoute
  '/client/assets/create': typeof ClientAssetsCreateRoute
  '/client/groups/$groupId': typeof ClientGroupsGroupIdRoute
  '/client/groups/create': typeof ClientGroupsCreateRoute
  '/client/locations/$locationId': typeof ClientLocationsLocationIdRoute
  '/client/locations/create': typeof ClientLocationsCreateRoute
  '/client/roles/$roleId': typeof ClientRolesRoleIdRoute
  '/client/roles/create': typeof ClientRolesCreateRoute
  '/client/users/$userId': typeof ClientUsersUserIdRoute
  '/client/users/create': typeof ClientUsersCreateRoute
  '/course-library/courses/$courseId': typeof CourseLibraryCoursesCourseIdRoute
  '/support/tickets/$ticketId': typeof SupportTicketsTicketIdRoute
  '/client/asset-groups': typeof ClientAssetGroupsIndexRoute
  '/client/assets': typeof ClientAssetsIndexRoute
  '/client/groups': typeof ClientGroupsIndexRoute
  '/client/locations': typeof ClientLocationsIndexRoute
  '/client/roles': typeof ClientRolesIndexRoute
  '/client/users': typeof ClientUsersIndexRoute
  '/course-library/terms': typeof CourseLibraryTermsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/access-denied': typeof AccessDeniedRoute
  '/admin-roles/$roleId': typeof AdminRolesRoleIdRoute
  '/agencies/$agencyId': typeof AgenciesAgencyIdRoute
  '/associations/$associationId': typeof AssociationsAssociationIdRoute
  '/checklist-library/$systemChecklistId': typeof ChecklistLibrarySystemChecklistIdRoute
  '/client-health/$clientId': typeof ClientHealthClientIdRoute
  '/client/asset-groups': typeof ClientAssetGroupsRouteWithChildren
  '/client/assets': typeof ClientAssetsRouteWithChildren
  '/client/checklist-library': typeof ClientChecklistLibraryRoute
  '/client/checklists': typeof ClientChecklistsRoute
  '/client/dashboard': typeof ClientDashboardRoute
  '/client/details': typeof ClientDetailsRoute
  '/client/layout-modes': typeof ClientLayoutModesRoute
  '/client/locations': typeof ClientLocationsRouteWithChildren
  '/client/onboarding': typeof ClientOnboardingRoute
  '/clients/create': typeof ClientsCreateRoute
  '/invoices/$invoiceId': typeof InvoicesInvoiceIdRoute
  '/plans/$planId': typeof PlansPlanIdRoute
  '/subscriptions/$subscriptionId': typeof SubscriptionsSubscriptionIdRoute
  '/support/settings': typeof SupportSettingsRoute
  '/users/$userId': typeof UsersUserIdRoute
  '/admin-roles/': typeof AdminRolesIndexRoute
  '/agencies/': typeof AgenciesIndexRoute
  '/associations/': typeof AssociationsIndexRoute
  '/checklist-library/': typeof ChecklistLibraryIndexRoute
  '/client-health/': typeof ClientHealthIndexRoute
  '/clients/': typeof ClientsIndexRoute
  '/course-library/': typeof CourseLibraryIndexRoute
  '/invoices/': typeof InvoicesIndexRoute
  '/plans/': typeof PlansIndexRoute
  '/quota-report/': typeof QuotaReportIndexRoute
  '/subscriptions/': typeof SubscriptionsIndexRoute
  '/support/': typeof SupportIndexRoute
  '/users/': typeof UsersIndexRoute
  '/client/asset-groups/$groupId': typeof ClientAssetGroupsGroupIdRoute
  '/client/assets/$assetId': typeof ClientAssetsAssetIdRoute
  '/client/assets/create': typeof ClientAssetsCreateRoute
  '/client/groups/$groupId': typeof ClientGroupsGroupIdRoute
  '/client/groups/create': typeof ClientGroupsCreateRoute
  '/client/locations/$locationId': typeof ClientLocationsLocationIdRoute
  '/client/locations/create': typeof ClientLocationsCreateRoute
  '/client/roles/$roleId': typeof ClientRolesRoleIdRoute
  '/client/roles/create': typeof ClientRolesCreateRoute
  '/client/users/$userId': typeof ClientUsersUserIdRoute
  '/client/users/create': typeof ClientUsersCreateRoute
  '/course-library/courses/$courseId': typeof CourseLibraryCoursesCourseIdRoute
  '/support/tickets/$ticketId': typeof SupportTicketsTicketIdRoute
  '/client/asset-groups/': typeof ClientAssetGroupsIndexRoute
  '/client/assets/': typeof ClientAssetsIndexRoute
  '/client/groups/': typeof ClientGroupsIndexRoute
  '/client/locations/': typeof ClientLocationsIndexRoute
  '/client/roles/': typeof ClientRolesIndexRoute
  '/client/users/': typeof ClientUsersIndexRoute
  '/course-library/terms/': typeof CourseLibraryTermsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/access-denied'
    | '/admin-roles/$roleId'
    | '/agencies/$agencyId'
    | '/associations/$associationId'
    | '/checklist-library/$systemChecklistId'
    | '/client-health/$clientId'
    | '/client/asset-groups'
    | '/client/assets'
    | '/client/checklist-library'
    | '/client/checklists'
    | '/client/dashboard'
    | '/client/details'
    | '/client/layout-modes'
    | '/client/locations'
    | '/client/onboarding'
    | '/clients/create'
    | '/invoices/$invoiceId'
    | '/plans/$planId'
    | '/subscriptions/$subscriptionId'
    | '/support/settings'
    | '/users/$userId'
    | '/admin-roles'
    | '/agencies'
    | '/associations'
    | '/checklist-library'
    | '/client-health'
    | '/clients'
    | '/course-library'
    | '/invoices'
    | '/plans'
    | '/quota-report'
    | '/subscriptions'
    | '/support'
    | '/users'
    | '/client/asset-groups/$groupId'
    | '/client/assets/$assetId'
    | '/client/assets/create'
    | '/client/groups/$groupId'
    | '/client/groups/create'
    | '/client/locations/$locationId'
    | '/client/locations/create'
    | '/client/roles/$roleId'
    | '/client/roles/create'
    | '/client/users/$userId'
    | '/client/users/create'
    | '/course-library/courses/$courseId'
    | '/support/tickets/$ticketId'
    | '/client/asset-groups/'
    | '/client/assets/'
    | '/client/groups'
    | '/client/locations/'
    | '/client/roles'
    | '/client/users'
    | '/course-library/terms'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/access-denied'
    | '/admin-roles/$roleId'
    | '/agencies/$agencyId'
    | '/associations/$associationId'
    | '/checklist-library/$systemChecklistId'
    | '/client-health/$clientId'
    | '/client/checklist-library'
    | '/client/checklists'
    | '/client/dashboard'
    | '/client/details'
    | '/client/layout-modes'
    | '/client/onboarding'
    | '/clients/create'
    | '/invoices/$invoiceId'
    | '/plans/$planId'
    | '/subscriptions/$subscriptionId'
    | '/support/settings'
    | '/users/$userId'
    | '/admin-roles'
    | '/agencies'
    | '/associations'
    | '/checklist-library'
    | '/client-health'
    | '/clients'
    | '/course-library'
    | '/invoices'
    | '/plans'
    | '/quota-report'
    | '/subscriptions'
    | '/support'
    | '/users'
    | '/client/asset-groups/$groupId'
    | '/client/assets/$assetId'
    | '/client/assets/create'
    | '/client/groups/$groupId'
    | '/client/groups/create'
    | '/client/locations/$locationId'
    | '/client/locations/create'
    | '/client/roles/$roleId'
    | '/client/roles/create'
    | '/client/users/$userId'
    | '/client/users/create'
    | '/course-library/courses/$courseId'
    | '/support/tickets/$ticketId'
    | '/client/asset-groups'
    | '/client/assets'
    | '/client/groups'
    | '/client/locations'
    | '/client/roles'
    | '/client/users'
    | '/course-library/terms'
  id:
    | '__root__'
    | '/'
    | '/access-denied'
    | '/admin-roles/$roleId'
    | '/agencies/$agencyId'
    | '/associations/$associationId'
    | '/checklist-library/$systemChecklistId'
    | '/client-health/$clientId'
    | '/client/asset-groups'
    | '/client/assets'
    | '/client/checklist-library'
    | '/client/checklists'
    | '/client/dashboard'
    | '/client/details'
    | '/client/layout-modes'
    | '/client/locations'
    | '/client/onboarding'
    | '/clients/create'
    | '/invoices/$invoiceId'
    | '/plans/$planId'
    | '/subscriptions/$subscriptionId'
    | '/support/settings'
    | '/users/$userId'
    | '/admin-roles/'
    | '/agencies/'
    | '/associations/'
    | '/checklist-library/'
    | '/client-health/'
    | '/clients/'
    | '/course-library/'
    | '/invoices/'
    | '/plans/'
    | '/quota-report/'
    | '/subscriptions/'
    | '/support/'
    | '/users/'
    | '/client/asset-groups/$groupId'
    | '/client/assets/$assetId'
    | '/client/assets/create'
    | '/client/groups/$groupId'
    | '/client/groups/create'
    | '/client/locations/$locationId'
    | '/client/locations/create'
    | '/client/roles/$roleId'
    | '/client/roles/create'
    | '/client/users/$userId'
    | '/client/users/create'
    | '/course-library/courses/$courseId'
    | '/support/tickets/$ticketId'
    | '/client/asset-groups/'
    | '/client/assets/'
    | '/client/groups/'
    | '/client/locations/'
    | '/client/roles/'
    | '/client/users/'
    | '/course-library/terms/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccessDeniedRoute: typeof AccessDeniedRoute
  AdminRolesRoleIdRoute: typeof AdminRolesRoleIdRoute
  AgenciesAgencyIdRoute: typeof AgenciesAgencyIdRoute
  AssociationsAssociationIdRoute: typeof AssociationsAssociationIdRoute
  ChecklistLibrarySystemChecklistIdRoute: typeof ChecklistLibrarySystemChecklistIdRoute
  ClientHealthClientIdRoute: typeof ClientHealthClientIdRoute
  ClientAssetGroupsRoute: typeof ClientAssetGroupsRouteWithChildren
  ClientAssetsRoute: typeof ClientAssetsRouteWithChildren
  ClientChecklistLibraryRoute: typeof ClientChecklistLibraryRoute
  ClientChecklistsRoute: typeof ClientChecklistsRoute
  ClientDashboardRoute: typeof ClientDashboardRoute
  ClientDetailsRoute: typeof ClientDetailsRoute
  ClientLayoutModesRoute: typeof ClientLayoutModesRoute
  ClientLocationsRoute: typeof ClientLocationsRouteWithChildren
  ClientOnboardingRoute: typeof ClientOnboardingRoute
  ClientsCreateRoute: typeof ClientsCreateRoute
  InvoicesInvoiceIdRoute: typeof InvoicesInvoiceIdRoute
  PlansPlanIdRoute: typeof PlansPlanIdRoute
  SubscriptionsSubscriptionIdRoute: typeof SubscriptionsSubscriptionIdRoute
  SupportSettingsRoute: typeof SupportSettingsRoute
  UsersUserIdRoute: typeof UsersUserIdRoute
  AdminRolesIndexRoute: typeof AdminRolesIndexRoute
  AgenciesIndexRoute: typeof AgenciesIndexRoute
  AssociationsIndexRoute: typeof AssociationsIndexRoute
  ChecklistLibraryIndexRoute: typeof ChecklistLibraryIndexRoute
  ClientHealthIndexRoute: typeof ClientHealthIndexRoute
  ClientsIndexRoute: typeof ClientsIndexRoute
  CourseLibraryIndexRoute: typeof CourseLibraryIndexRoute
  InvoicesIndexRoute: typeof InvoicesIndexRoute
  PlansIndexRoute: typeof PlansIndexRoute
  QuotaReportIndexRoute: typeof QuotaReportIndexRoute
  SubscriptionsIndexRoute: typeof SubscriptionsIndexRoute
  SupportIndexRoute: typeof SupportIndexRoute
  UsersIndexRoute: typeof UsersIndexRoute
  ClientGroupsGroupIdRoute: typeof ClientGroupsGroupIdRoute
  ClientGroupsCreateRoute: typeof ClientGroupsCreateRoute
  ClientRolesRoleIdRoute: typeof ClientRolesRoleIdRoute
  ClientRolesCreateRoute: typeof ClientRolesCreateRoute
  ClientUsersUserIdRoute: typeof ClientUsersUserIdRoute
  ClientUsersCreateRoute: typeof ClientUsersCreateRoute
  CourseLibraryCoursesCourseIdRoute: typeof CourseLibraryCoursesCourseIdRoute
  SupportTicketsTicketIdRoute: typeof SupportTicketsTicketIdRoute
  ClientGroupsIndexRoute: typeof ClientGroupsIndexRoute
  ClientRolesIndexRoute: typeof ClientRolesIndexRoute
  ClientUsersIndexRoute: typeof ClientUsersIndexRoute
  CourseLibraryTermsIndexRoute: typeof CourseLibraryTermsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/access-denied': {
      id: '/access-denied'
      path: '/access-denied'
      fullPath: '/access-denied'
      preLoaderRoute: typeof AccessDeniedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/': {
      id: '/users/'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof UsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support/': {
      id: '/support/'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof SupportIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/subscriptions/': {
      id: '/subscriptions/'
      path: '/subscriptions'
      fullPath: '/subscriptions'
      preLoaderRoute: typeof SubscriptionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/quota-report/': {
      id: '/quota-report/'
      path: '/quota-report'
      fullPath: '/quota-report'
      preLoaderRoute: typeof QuotaReportIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/plans/': {
      id: '/plans/'
      path: '/plans'
      fullPath: '/plans'
      preLoaderRoute: typeof PlansIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices/': {
      id: '/invoices/'
      path: '/invoices'
      fullPath: '/invoices'
      preLoaderRoute: typeof InvoicesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/course-library/': {
      id: '/course-library/'
      path: '/course-library'
      fullPath: '/course-library'
      preLoaderRoute: typeof CourseLibraryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clients/': {
      id: '/clients/'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof ClientsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/client-health/': {
      id: '/client-health/'
      path: '/client-health'
      fullPath: '/client-health'
      preLoaderRoute: typeof ClientHealthIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checklist-library/': {
      id: '/checklist-library/'
      path: '/checklist-library'
      fullPath: '/checklist-library'
      preLoaderRoute: typeof ChecklistLibraryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/associations/': {
      id: '/associations/'
      path: '/associations'
      fullPath: '/associations'
      preLoaderRoute: typeof AssociationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agencies/': {
      id: '/agencies/'
      path: '/agencies'
      fullPath: '/agencies'
      preLoaderRoute: typeof AgenciesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin-roles/': {
      id: '/admin-roles/'
      path: '/admin-roles'
      fullPath: '/admin-roles'
      preLoaderRoute: typeof AdminRolesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/$userId': {
      id: '/users/$userId'
      path: '/users/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof UsersUserIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support/settings': {
      id: '/support/settings'
      path: '/support/settings'
      fullPath: '/support/settings'
      preLoaderRoute: typeof SupportSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/subscriptions/$subscriptionId': {
      id: '/subscriptions/$subscriptionId'
      path: '/subscriptions/$subscriptionId'
      fullPath: '/subscriptions/$subscriptionId'
      preLoaderRoute: typeof SubscriptionsSubscriptionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/plans/$planId': {
      id: '/plans/$planId'
      path: '/plans/$planId'
      fullPath: '/plans/$planId'
      preLoaderRoute: typeof PlansPlanIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices/$invoiceId': {
      id: '/invoices/$invoiceId'
      path: '/invoices/$invoiceId'
      fullPath: '/invoices/$invoiceId'
      preLoaderRoute: typeof InvoicesInvoiceIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clients/create': {
      id: '/clients/create'
      path: '/clients/create'
      fullPath: '/clients/create'
      preLoaderRoute: typeof ClientsCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/client/onboarding': {
      id: '/client/onboarding'
      path: '/client/onboarding'
      fullPath: '/client/onboarding'
      preLoaderRoute: typeof ClientOnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/client/locations': {
      id: '/client/locations'
      path: '/client/locations'
      fullPath: '/client/locations'
      preLoaderRoute: typeof ClientLocationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/client/layout-modes': {
      id: '/client/layout-modes'
      path: '/client/layout-modes'
      fullPath: '/client/layout-modes'
      preLoaderRoute: typeof ClientLayoutModesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/client/details': {
      id: '/client/details'
      path: '/client/details'
      fullPath: '/client/details'
      preLoaderRoute: typeof ClientDetailsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/client/dashboard': {
      id: '/client/dashboard'
      path: '/client/dashboard'
      fullPath: '/client/dashboard'
      preLoaderRoute: typeof ClientDashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/client/checklists': {
      id: '/client/checklists'
      path: '/client/checklists'
      fullPath: '/client/checklists'
      preLoaderRoute: typeof ClientChecklistsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/client/checklist-library': {
      id: '/client/checklist-library'
      path: '/client/checklist-library'
      fullPath: '/client/checklist-library'
      preLoaderRoute: typeof ClientChecklistLibraryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/client/assets': {
      id: '/client/assets'
      path: '/client/assets'
      fullPath: '/client/assets'
      preLoaderRoute: typeof ClientAssetsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/client/asset-groups': {
      id: '/client/asset-groups'
      path: '/client/asset-groups'
      fullPath: '/client/asset-groups'
      preLoaderRoute: typeof ClientAssetGroupsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/client-health/$clientId': {
      id: '/client-health/$clientId'
      path: '/client-health/$clientId'
      fullPath: '/client-health/$clientId'
      preLoaderRoute: typeof ClientHealthClientIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checklist-library/$systemChecklistId': {
      id: '/checklist-library/$systemChecklistId'
      path: '/checklist-library/$systemChecklistId'
      fullPath: '/checklist-library/$systemChecklistId'
      preLoaderRoute: typeof ChecklistLibrarySystemChecklistIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/associations/$associationId': {
      id: '/associations/$associationId'
      path: '/associations/$associationId'
      fullPath: '/associations/$associationId'
      preLoaderRoute: typeof AssociationsAssociationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agencies/$agencyId': {
      id: '/agencies/$agencyId'
      path: '/agencies/$agencyId'
      fullPath: '/agencies/$agencyId'
      preLoaderRoute: typeof AgenciesAgencyIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin-roles/$roleId': {
      id: '/admin-roles/$roleId'
      path: '/admin-roles/$roleId'
      fullPath: '/admin-roles/$roleId'
      preLoaderRoute: typeof AdminRolesRoleIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/course-library/terms/': {
      id: '/course-library/terms/'
      path: '/course-library/terms'
      fullPath: '/course-library/terms'
      preLoaderRoute: typeof CourseLibraryTermsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/client/users/': {
      id: '/client/users/'
      path: '/client/users'
      fullPath: '/client/users'
      preLoaderRoute: typeof ClientUsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/client/roles/': {
      id: '/client/roles/'
      path: '/client/roles'
      fullPath: '/client/roles'
      preLoaderRoute: typeof ClientRolesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/client/locations/': {
      id: '/client/locations/'
      path: '/'
      fullPath: '/client/locations/'
      preLoaderRoute: typeof ClientLocationsIndexRouteImport
      parentRoute: typeof ClientLocationsRoute
    }
    '/client/groups/': {
      id: '/client/groups/'
      path: '/client/groups'
      fullPath: '/client/groups'
      preLoaderRoute: typeof ClientGroupsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/client/assets/': {
      id: '/client/assets/'
      path: '/'
      fullPath: '/client/assets/'
      preLoaderRoute: typeof ClientAssetsIndexRouteImport
      parentRoute: typeof ClientAssetsRoute
    }
    '/client/asset-groups/': {
      id: '/client/asset-groups/'
      path: '/'
      fullPath: '/client/asset-groups/'
      preLoaderRoute: typeof ClientAssetGroupsIndexRouteImport
      parentRoute: typeof ClientAssetGroupsRoute
    }
    '/support/tickets/$ticketId': {
      id: '/support/tickets/$ticketId'
      path: '/support/tickets/$ticketId'
      fullPath: '/support/tickets/$ticketId'
      preLoaderRoute: typeof SupportTicketsTicketIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/course-library/courses/$courseId': {
      id: '/course-library/courses/$courseId'
      path: '/course-library/courses/$courseId'
      fullPath: '/course-library/courses/$courseId'
      preLoaderRoute: typeof CourseLibraryCoursesCourseIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/client/users/create': {
      id: '/client/users/create'
      path: '/client/users/create'
      fullPath: '/client/users/create'
      preLoaderRoute: typeof ClientUsersCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/client/users/$userId': {
      id: '/client/users/$userId'
      path: '/client/users/$userId'
      fullPath: '/client/users/$userId'
      preLoaderRoute: typeof ClientUsersUserIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/client/roles/create': {
      id: '/client/roles/create'
      path: '/client/roles/create'
      fullPath: '/client/roles/create'
      preLoaderRoute: typeof ClientRolesCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/client/roles/$roleId': {
      id: '/client/roles/$roleId'
      path: '/client/roles/$roleId'
      fullPath: '/client/roles/$roleId'
      preLoaderRoute: typeof ClientRolesRoleIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/client/locations/create': {
      id: '/client/locations/create'
      path: '/create'
      fullPath: '/client/locations/create'
      preLoaderRoute: typeof ClientLocationsCreateRouteImport
      parentRoute: typeof ClientLocationsRoute
    }
    '/client/locations/$locationId': {
      id: '/client/locations/$locationId'
      path: '/$locationId'
      fullPath: '/client/locations/$locationId'
      preLoaderRoute: typeof ClientLocationsLocationIdRouteImport
      parentRoute: typeof ClientLocationsRoute
    }
    '/client/groups/create': {
      id: '/client/groups/create'
      path: '/client/groups/create'
      fullPath: '/client/groups/create'
      preLoaderRoute: typeof ClientGroupsCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/client/groups/$groupId': {
      id: '/client/groups/$groupId'
      path: '/client/groups/$groupId'
      fullPath: '/client/groups/$groupId'
      preLoaderRoute: typeof ClientGroupsGroupIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/client/assets/create': {
      id: '/client/assets/create'
      path: '/create'
      fullPath: '/client/assets/create'
      preLoaderRoute: typeof ClientAssetsCreateRouteImport
      parentRoute: typeof ClientAssetsRoute
    }
    '/client/assets/$assetId': {
      id: '/client/assets/$assetId'
      path: '/$assetId'
      fullPath: '/client/assets/$assetId'
      preLoaderRoute: typeof ClientAssetsAssetIdRouteImport
      parentRoute: typeof ClientAssetsRoute
    }
    '/client/asset-groups/$groupId': {
      id: '/client/asset-groups/$groupId'
      path: '/$groupId'
      fullPath: '/client/asset-groups/$groupId'
      preLoaderRoute: typeof ClientAssetGroupsGroupIdRouteImport
      parentRoute: typeof ClientAssetGroupsRoute
    }
  }
}

interface ClientAssetGroupsRouteChildren {
  ClientAssetGroupsGroupIdRoute: typeof ClientAssetGroupsGroupIdRoute
  ClientAssetGroupsIndexRoute: typeof ClientAssetGroupsIndexRoute
}

const ClientAssetGroupsRouteChildren: ClientAssetGroupsRouteChildren = {
  ClientAssetGroupsGroupIdRoute: ClientAssetGroupsGroupIdRoute,
  ClientAssetGroupsIndexRoute: ClientAssetGroupsIndexRoute,
}

const ClientAssetGroupsRouteWithChildren =
  ClientAssetGroupsRoute._addFileChildren(ClientAssetGroupsRouteChildren)

interface ClientAssetsRouteChildren {
  ClientAssetsAssetIdRoute: typeof ClientAssetsAssetIdRoute
  ClientAssetsCreateRoute: typeof ClientAssetsCreateRoute
  ClientAssetsIndexRoute: typeof ClientAssetsIndexRoute
}

const ClientAssetsRouteChildren: ClientAssetsRouteChildren = {
  ClientAssetsAssetIdRoute: ClientAssetsAssetIdRoute,
  ClientAssetsCreateRoute: ClientAssetsCreateRoute,
  ClientAssetsIndexRoute: ClientAssetsIndexRoute,
}

const ClientAssetsRouteWithChildren = ClientAssetsRoute._addFileChildren(
  ClientAssetsRouteChildren,
)

interface ClientLocationsRouteChildren {
  ClientLocationsLocationIdRoute: typeof ClientLocationsLocationIdRoute
  ClientLocationsCreateRoute: typeof ClientLocationsCreateRoute
  ClientLocationsIndexRoute: typeof ClientLocationsIndexRoute
}

const ClientLocationsRouteChildren: ClientLocationsRouteChildren = {
  ClientLocationsLocationIdRoute: ClientLocationsLocationIdRoute,
  ClientLocationsCreateRoute: ClientLocationsCreateRoute,
  ClientLocationsIndexRoute: ClientLocationsIndexRoute,
}

const ClientLocationsRouteWithChildren = ClientLocationsRoute._addFileChildren(
  ClientLocationsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccessDeniedRoute: AccessDeniedRoute,
  AdminRolesRoleIdRoute: AdminRolesRoleIdRoute,
  AgenciesAgencyIdRoute: AgenciesAgencyIdRoute,
  AssociationsAssociationIdRoute: AssociationsAssociationIdRoute,
  ChecklistLibrarySystemChecklistIdRoute:
    ChecklistLibrarySystemChecklistIdRoute,
  ClientHealthClientIdRoute: ClientHealthClientIdRoute,
  ClientAssetGroupsRoute: ClientAssetGroupsRouteWithChildren,
  ClientAssetsRoute: ClientAssetsRouteWithChildren,
  ClientChecklistLibraryRoute: ClientChecklistLibraryRoute,
  ClientChecklistsRoute: ClientChecklistsRoute,
  ClientDashboardRoute: ClientDashboardRoute,
  ClientDetailsRoute: ClientDetailsRoute,
  ClientLayoutModesRoute: ClientLayoutModesRoute,
  ClientLocationsRoute: ClientLocationsRouteWithChildren,
  ClientOnboardingRoute: ClientOnboardingRoute,
  ClientsCreateRoute: ClientsCreateRoute,
  InvoicesInvoiceIdRoute: InvoicesInvoiceIdRoute,
  PlansPlanIdRoute: PlansPlanIdRoute,
  SubscriptionsSubscriptionIdRoute: SubscriptionsSubscriptionIdRoute,
  SupportSettingsRoute: SupportSettingsRoute,
  UsersUserIdRoute: UsersUserIdRoute,
  AdminRolesIndexRoute: AdminRolesIndexRoute,
  AgenciesIndexRoute: AgenciesIndexRoute,
  AssociationsIndexRoute: AssociationsIndexRoute,
  ChecklistLibraryIndexRoute: ChecklistLibraryIndexRoute,
  ClientHealthIndexRoute: ClientHealthIndexRoute,
  ClientsIndexRoute: ClientsIndexRoute,
  CourseLibraryIndexRoute: CourseLibraryIndexRoute,
  InvoicesIndexRoute: InvoicesIndexRoute,
  PlansIndexRoute: PlansIndexRoute,
  QuotaReportIndexRoute: QuotaReportIndexRoute,
  SubscriptionsIndexRoute: SubscriptionsIndexRoute,
  SupportIndexRoute: SupportIndexRoute,
  UsersIndexRoute: UsersIndexRoute,
  ClientGroupsGroupIdRoute: ClientGroupsGroupIdRoute,
  ClientGroupsCreateRoute: ClientGroupsCreateRoute,
  ClientRolesRoleIdRoute: ClientRolesRoleIdRoute,
  ClientRolesCreateRoute: ClientRolesCreateRoute,
  ClientUsersUserIdRoute: ClientUsersUserIdRoute,
  ClientUsersCreateRoute: ClientUsersCreateRoute,
  CourseLibraryCoursesCourseIdRoute: CourseLibraryCoursesCourseIdRoute,
  SupportTicketsTicketIdRoute: SupportTicketsTicketIdRoute,
  ClientGroupsIndexRoute: ClientGroupsIndexRoute,
  ClientRolesIndexRoute: ClientRolesIndexRoute,
  ClientUsersIndexRoute: ClientUsersIndexRoute,
  CourseLibraryTermsIndexRoute: CourseLibraryTermsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
